<main>
    <nav class="navbar">
        <a routerLink="/" class="logo-link">
            <img class="logo" src="/assets/images/icon.png" alt="Cinema Logo">
        </a>
        <ul>
            <li class="text-primary"><a class="fancy-links" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{ languageService.t('home') }}</a></li>

            <li class="nav-dropdown-wrapper" (mouseenter)="activeDropdown = 'movie'" (mouseleave)="activeDropdown = null">
                <a class="fancy-links has-dropdown" [routerLink]="['/movies/popular']" routerLinkActive="active">
                    <span>{{ languageService.t('movie') }}</span>
                    <svg class="dropdown-chevron" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="m6 9 6 6 6-6"/></svg>
                </a>
                <div class="nav-dropdown-menu" *ngIf="activeDropdown === 'movie'">
                    <a class="nav-dropdown-item" [routerLink]="['/movies/popular']" routerLinkActive="dropdown-active" (click)="activeDropdown = null">
                        <span class="dropdown-item-title">{{ languageService.t('popular') }}</span>
                        <span class="dropdown-item-desc">Hollywood &amp; trending</span>
                    </a>
                    <a class="nav-dropdown-item" [routerLink]="['/movies/now-playing']" routerLinkActive="dropdown-active" (click)="activeDropdown = null">
                        <span class="dropdown-item-title">{{ languageService.t('nowPlaying') }}</span>
                        <span class="dropdown-item-desc">In theatres now</span>
                    </a>
                    <a class="nav-dropdown-item" [routerLink]="['/movies/upcoming']" routerLinkActive="dropdown-active" (click)="activeDropdown = null">
                        <span class="dropdown-item-title">{{ languageService.t('upcoming') }}</span>
                        <span class="dropdown-item-desc">Anticipated releases</span>
                    </a>
                    <a class="nav-dropdown-item" [routerLink]="['/movies/top-rated']" routerLinkActive="dropdown-active" (click)="activeDropdown = null">
                        <span class="dropdown-item-title">{{ languageService.t('topRated') }}</span>
                        <span class="dropdown-item-desc">All-time highest rated</span>
                    </a>
                </div>
            </li>

            <li class="nav-dropdown-wrapper" (mouseenter)="activeDropdown = 'tv'" (mouseleave)="activeDropdown = null">
                <a class="fancy-links has-dropdown" [routerLink]="['/tv/popular']" routerLinkActive="active">
                    <span>{{ languageService.t('tv') }}</span>
                    <svg class="dropdown-chevron" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="m6 9 6 6 6-6"/></svg>
                </a>
                <div class="nav-dropdown-menu" *ngIf="activeDropdown === 'tv'">
                    <a class="nav-dropdown-item" [routerLink]="['/tv/popular']" routerLinkActive="dropdown-active" (click)="activeDropdown = null">
                        <span class="dropdown-item-title">{{ languageService.t('popular') }}</span>
                        <span class="dropdown-item-desc">Trending television</span>
                    </a>
                    <a class="nav-dropdown-item" [routerLink]="['/tv/airing-today']" routerLinkActive="dropdown-active" (click)="activeDropdown = null">
                        <span class="dropdown-item-title">{{ languageService.t('airingToday') }}</span>
                        <span class="dropdown-item-desc">Episodes on today</span>
                    </a>
                    <a class="nav-dropdown-item" [routerLink]="['/tv/on-the-air']" routerLinkActive="dropdown-active" (click)="activeDropdown = null">
                        <span class="dropdown-item-title">{{ languageService.t('onTheAir') }}</span>
                        <span class="dropdown-item-desc">Currently broadcasting</span>
                    </a>
                    <a class="nav-dropdown-item" [routerLink]="['/tv/top-rated']" routerLinkActive="dropdown-active" (click)="activeDropdown = null">
                        <span class="dropdown-item-title">{{ languageService.t('topRated') }}</span>
                        <span class="dropdown-item-desc">Critically acclaimed</span>
                    </a>
                </div>
            </li>

            <li class="nav-dropdown-wrapper" (mouseenter)="activeDropdown = 'person'" (mouseleave)="activeDropdown = null">
                <a class="fancy-links has-dropdown" [routerLink]="['/person/popular']" routerLinkActive="active">
                    <span>{{ languageService.t('person') }}</span>
                    <svg class="dropdown-chevron" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="m6 9 6 6 6-6"/></svg>
                </a>
                <div class="nav-dropdown-menu" *ngIf="activeDropdown === 'person'">
                    <a class="nav-dropdown-item" [routerLink]="['/person/popular']" routerLinkActive="dropdown-active" (click)="activeDropdown = null">
                        <span class="dropdown-item-title">{{ languageService.t('popularPeople') }}</span>
                        <span class="dropdown-item-desc">Hollywood stars &amp; creators</span>
                    </a>
                </div>
            </li>

            <li class="text-primary"><a class="fancy-links" [routerLink]="['/quiz']" routerLinkActive="active">{{ languageService.t('trivia') }}</a></li>
            <li class="text-primary"><a class="fancy-links" [routerLink]="['/blogs']" routerLinkActive="active">{{ languageService.t('blogs') }}</a></li>
        </ul>
        <div class="nav-actions">
            <app-nav-search></app-nav-search>
            <app-language-selector></app-language-selector>
            <a *ngIf="!authToken || !userDetails" routerLink="/auth" class="btn-get-started">{{ languageService.t('getStarted') }}</a>

            <!-- Profile Dropdown -->
            <div class="profile-dropdown-wrapper" *ngIf="authToken && userDetails"
                (mouseenter)="onProfileMouseEnter()" (mouseleave)="onProfileMouseLeave()">
                <button class="profile-trigger" (click)="toggleProfileDropdown($event)">
                    <img #profileImage class="profile-image"
                        [src]="userDetails?.profile_picture || '/assets/images/avatar.png'"
                        [alt]="userDetails?.name || 'Profile'"
                        (error)="onImageError($event)">
                </button>
                <div class="profile-dropdown" *ngIf="showProfileDropdown"
                    (mouseenter)="onProfileMouseEnter()" (mouseleave)="onProfileMouseLeave()">
                    <div class="profile-dropdown-header">
                        <img class="dropdown-avatar" [src]="userDetails?.profile_picture || '/assets/images/avatar.png'" (error)="onImageError($event)" alt="">
                        <div class="dropdown-user-info">
                            <span class="dropdown-name">{{ userDetails?.name }}</span>
                            <span class="dropdown-email">{{ userDetails?.email }}</span>
                        </div>
                    </div>
                    <div class="profile-dropdown-divider"></div>
                    <a class="profile-dropdown-item" [routerLink]="['/u', profileNameFilter(userDetails?.name || '')]" (click)="showProfileDropdown = false">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                        {{ languageService.t('myProfile') }}
                    </a>
                    <a class="profile-dropdown-item" [routerLink]="['/u', profileNameFilter(userDetails?.name || '')]" [queryParams]="{edit: true}" (click)="showProfileDropdown = false">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                        {{ languageService.t('editProfile') }}
                    </a>
                    <div class="profile-dropdown-divider"></div>
                    <button class="profile-dropdown-item logout" (click)="logout()">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                        {{ languageService.t('logout') }}
                    </button>
                </div>
            </div>
        </div>
    </nav>
    <app-mobile-navbar class="mobile"></app-mobile-navbar>
</main>
